module.exports = __webpack_public_path__ + "static/media/Pin.3b3ff5b3.svg";